<app-navigation></app-navigation>
@if (!hideInfo()) {
  <app-information [isOnDashboard]="isOnDashboard"></app-information>
}
